<template>
  <el-container class='box'>
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' :searchEnd='searchEnd' v-on:getSearchObj='getSearchObj' :rightEventList='rightEventList'
        @rightFunc='rightFunc' />
    </div>
    <el-main class="listTabel">
      <BaseTable :data="tableData" :optimize='true' tooltip-effect="dark" :column="tableConfig" pagination
        :auto-scroll="true" :total="total" :page.sync="searchParams.current" :limit.sync="searchParams.size"
        @pagination="getList">
      </BaseTable>
    </el-main>
  </el-container>
</template>

<script>
import { cardPage, updateStatus } from "@/api/cardPwd.js";
import local from "@/utils/local.js";
export default { 
  props: {},
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "卡密管理" }],
      rightEventList: [{ eventName: "新增渠道兑换卡", eventValue: 1 }],
      searchList: [
        {
          label: "合作机构",
          value: 1,
          paramName: "cardChannelId",
          inputType: "channelId"
        },
        {
          label: "兑换状态",
          value: 2,
          paramName: "cashState",
          inputType: "select",
          default: null,
          optionData: [
            {
              label: "生效中",
              value: "2"
            },
            {
              label: "已过期",
              value: "3"
            },
            {
              label: "未开始",
              value: "1"
            }
          ]
        }
      ],
      searchEnd:{},
      searchParams: {
        size: 10,
        current: 1
      },
      tableData: [],
      tableConfig: [
        {
          label: "合作机构",
          align: "center",
          prop: "cardChannelOrg"
        },
        {
          label: "合作项目",
          align: "center",
          prop: "coopItem"
        },
        {
          label: "兑换卡名称",
          align: "center",
          prop: "cardName",
          size: "mini"
        },
        {
          label: "分账模式",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.splitAccountModel == 1
                  ? "无分账"
                  : scope.row.splitAccountModel == 2
                  ? "进账"
                  : "出账"}
              </span>
            );
          }
        },
        {
          label: "兑换状态",
          align: "center",
          render: (h, scope) => {
            return h("span", {
              style: {
                backgroundColor: scope.row.cardCashState == 2 ? "#D3F3E2": scope.row.cardCashState == 3?"#EEEEEE":"#FFECDB",
                padding:'5px', 
                borderRadius: '2px', 
              }  
            },
            scope.row.cardCashState == 2 ? "生效中": scope.row.cardCashState == 3? "已过期": "未开始"
           )
          }
        },
        {
          label: "是否启用",
          align: "center",
          render: (h, scope) => { 
            return h("span", {
              style: {
                backgroundColor: scope.row.cardState == 1 ? "#0CB79F":"#FCB023",
                padding:'5px', 
                borderRadius: '2px',
                color:'#fff'
              }  
            },
            scope.row.cardState == 1 ? "是" : "否"
           );
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onLookClick(scope.row,"view");
                    }
                  }
                },
                "查看"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini",
                    disabled:scope.row.cardState==1?true:false
                  },
                  on: {
                    click: () => {
                      this.onLookClick(scope.row,"edite");
                    }
                  }
                },
                "编辑"
              ),
              ,
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.copyUrl(scope.row.cardH5Url);
                    }
                  }
                },
                "复制链接"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.recordClick(scope.row);
                    }
                  }
                },
                "使用记录"
              ),
              ,
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.enableTheClick(scope.row);
                    }
                  }
                },
                scope.row.cardState ? "禁用" : "启用"
              )
            ]);
          }
        }
      ],
      total: 0
    };
  },
  created() {
    let end = this.$route.params;  
    if(end && end.condition){
      this.searchEnd = end.condition; 
      this.searchParams = { ...this.searchParams, ...this.searchEnd };
    }  
    this.getList();
  },
  methods: {
    // 编辑|| 查看
    onLookClick(row, type) {
      local.set("cardPwdListCon", JSON.stringify(this.searchParams));
      this.$router.push({
        path: "/termPage/addCardPwd",
        query: {type: type, cardId: row.cardId }
      });
    },
    //启用||停用
    enableTheClick(row) {
      let params = {
        cardId: row.cardId,
        cardState: row.cardState?0:1
      };
      updateStatus(params).then(res => {
        if (res.code == 0) {
          this.getList();
          if (!row.cardState) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("停用成功");
          }
        }
      });
    },
    copyUrl(url) {
      this.$copyText(url).then(
        e => {
          this.$message.success("复制成功！");
        },
        e => {
          console.log(e);
          this.$message.error("复制失败！");
        }
      );
    },
    recordClick(row) {
      this.$router.push({
        path: "/termPage/cardPwdRecord",
        query: { cardId: row.cardId }
      });
    },
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...this.searchParams, ...obj };
      this.getList();
    },
    getList() {
      cardPage(this.searchParams)
        .then(result => {
          this.total = result.data.total;
          this.tableData = result.data.records;
        })
        .catch(err => {});
    },
    rightFunc() {
      this.$router.push({
        path: "/termPage/addCardPwd",
        query: { type: "add" }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;

}
</style>
